export function openModal (modal) {
  const existingModalBackdrop = Array.from(document.getElementsByClassName('modal-backdrop'))[0]
  const modalBackdrop = document.createElement('div')

  document.body.classList.add('modal-open')
  if (existingModalBackdrop === undefined) {
    document.body.appendChild(modalBackdrop)
    modalBackdrop.classList.add('modal-backdrop', 'fade', 'in')
  }

  modal.classList.add('in')
  modal.style.display = 'block'
  modal.onclick = e => {
    if (e.target === modal || e.target.classList.contains('close-modal')) {
      closeModal(modal)
    }
  }
}

export function closeModal (modal) {
  document.body.classList.remove('modal-open')
  const modalBackdrops = Array.from(document.getElementsByClassName('modal-backdrop'))

  if (modalBackdrops) {
    modalBackdrops.forEach(modalBackdrop => {
      modalBackdrop.remove()
    })
  }

  modal.classList.remove('in')
  modal.style.display = 'none'
}

export function initModal (linkClassName, modalId) {
  const links = Array.from(document.getElementsByClassName(linkClassName))
  if (links) {
    links.forEach(link => {
      link.addEventListener('click', function () {
        const modal = document.getElementById(modalId)
        openModal(modal)
      })
    })
  }
}
